import React from 'react'
import { ReactComponent as ChevronIcon } from '@icons/chevron.svg'
import styled from 'styled-components'
import { colors, typography } from '@styles/vars'
import { useTableContext } from '../context'

export default function Pagination() {
    const {
        nextPage,
        previousPage,
        rows,
        page,
        canNextPage,
        canPreviousPage,
        state
    } = useTableContext()

    const firstRowOnPage = state.pageIndex * state.pageSize + (page.length ? 1 : 0)
    const lastRowOnPage = state.pageIndex * state.pageSize + page.length

    return (
        <Wrapper>
            <Label><p>Rows {firstRowOnPage} - {lastRowOnPage} of {rows.length}</p></Label>
            <Navigation>
                <NavigationPrev disabled={!canPreviousPage} onClick={previousPage}><ChevronIcon /></NavigationPrev>
                <NavigationNext disabled={!canNextPage} className="table-pagination__next" onClick={nextPage}><ChevronIcon /></NavigationNext>
            </Navigation>
        </Wrapper>
    )
}

// STYLES
const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const Label = styled.div`
    margin-right: 10px;

    p {
        font-size: ${typography.sizes.s};
        font-weight: 700;
        color: ${colors.darkGrey};
    }
`

const Navigation = styled.div`
    &__navigation {
        display: flex;
        margin-left: 10px;
    }
`

const NavigationButton = styled.button`
    background: transparent;
    border:0;
    padding: 0;
    cursor: pointer;
    width: 36px;
    height: 36px;

    &:disabled {
        opacity: 0.6;
        cursor: auto;

        &:hover svg {
            fill: $light-grey-color;
        }
    }

    svg {
        fill: $light-grey-color;
        width: 100%;
        height: 100%;
    }

    &:focus {
        outline: none;
    }

    &:hover {
        svg {
            fill: $primary-color;
        }
    }
`

const NavigationPrev = styled(NavigationButton)`
    transform: rotate(90deg);
`

const NavigationNext = styled(NavigationButton)`
    transform: rotate(-90deg);
`